// Lightweight cross-component bridge so any page can open the floating Homie
// bubble with a pre-seeded question. Keeps Homie and other tools (Stack,
// Grant Finder, etc.) in sync without lifting state into a global store.

export const HOMIE_OPEN_EVENT = "homie:open";

export interface HomieOpenDetail {
  prompt?: string;
  /** Optional source label for analytics */
  source?: string;
}

export function openHomie(detail: HomieOpenDetail = {}): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<HomieOpenDetail>(HOMIE_OPEN_EVENT, { detail }));
}